<template>
  <div class="StatCircle">
    <div class="StatCircle-circle">
      <el-progress
        color="#0bb1be"
        v-bind="$attrs"
        type="circle"
        :percentage="percentage"
        :stroke-width="10"
        :show-text="false"
        :width="180"
      ></el-progress>
    </div>
    <div class="StatCircle-text">
      <stat-value
        :value="value"
        :subValue="subValue"
        :label="label"
        class="StatCircle-value"
      >
        <template v-slot:label>
          <slot name="label"></slot>
        </template>
      </stat-value>
    </div>
  </div>
</template>

<style lang="scss">
.StatCircle {
  align-items: center;
  display: flex;
  height: 180px;
  justify-content: center;
  width: 180px;
  &-circle {
    position: absolute;
  }
  &-value {
    text-align: center;
  }
}
</style>

<script>
import { Progress } from 'element-ui'
import StatValue from './StatValue.vue'

/**
 * Valeur statistique avec graphique.
 *
 * @see StatValue
 */
export default {
  name: 'UbiStatCircle',
  components: {
    ElProgress: Progress,
    StatValue
  },
  props: {
    /**
     * Valeur
     */
    value: { type: [String, Number], required: true },
    /**
     * Sous-valeur ou précision
     */
    total: { type: [String, Number], required: true },
    /**
     * Unité / label de la valeur
     */
    label: String
  },
  computed: {
    valueNumber () {
      return typeof this.value === 'number' ? this.value : Number(this.value)
    },
    totalNumber () {
      return typeof this.total === 'number' ? this.total : Number(this.total)
    },
    percentage () {
      return this.valueNumber === 0 && this.totalNumber === 0 ? 0 : (100 * this.valueNumber) / (this.totalNumber || this.valueNumber)
    },
    subValue () {
      return this.total
    }
  }
}
</script>

<docs>
### Exemples

```jsx
<ubi-stat-circle :value="41" :total="54" label="Produits vendus"/>
```
</docs>
